// extracted by mini-css-extract-plugin
export default {"lottie":"T59Y3qL2dAN18yZX2Y-XCw=="};